// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"338":"970a41af","692":"0e073f7d"}[chunkId] + ".css";
};